// extracted by mini-css-extract-plugin
export default {"container":"container__bL8KpoTLa_FK3BRf6H1Q","alertIcon":"alertIcon__WoQ4fXrWrmNrJDRDzSd7","text":"text__f7OcQnNMq4YyOGc6ZAIJ","closeButton":"closeButton__ig942zmWYcM8pyQMmRjf"};